import { API } from '../core/api';

type OrderStatus = 'paid' | 'new' | 'paying';

type PaymentRaw = {
	russian_trade_name: string;
	buyer_description: string;
	amount: number;
	discount_amount: number;
	sberpay_available: boolean;
	payment_method: {
		operator: 'gpb' | 'sberpay'
	};
	qr_link: string;
	qr_image: string;
	nspk_link: string;
	order_status: OrderStatus;
	receipt_link: string;
	order_id: number;
	is_redirect: string;
	redirect_url: string;
	discount: number;
	promocode: string;
	external_id?: string;
	sberpayAvailable?: boolean;
	sbpAvailable?: boolean;
	tpayAvailable?: boolean;
};

export class Payment {
	constructor(private payment: PaymentRaw) {}

	get isPaid() {
		return this.payment.order_status === 'paid';
	}

	get isNew() {
		return this.payment.order_status === 'new';
	}

	get isPaying() {
		return this.payment.order_status === 'paying';
	}

	get isLikeAsNew() {
		return ['new', 'process', 'paying'].includes(this.payment.order_status);
	}

	get amount() {
		return this.payment.amount;
	}

	get qr_image() {
		return this.payment.qr_image;
	}

	get russian_trade_name() {
		return this.payment.russian_trade_name;
	}
	get buyer_description() {
		return this.payment.buyer_description;
	}
	get discount_amount() {
		return this.payment.discount_amount;
	}

	get discount() {
		return this.payment.discount;
	}

	get promocode() {
		return this.payment.promocode;
	}

	get qr_link() {
		return this.payment.qr_link;
	}
	get nspk_link() {
		return this.payment.nspk_link;
	}
	get order_status() {
		return this.payment.order_status;
	}

	get receipt_link() {
		return this.payment.receipt_link;
	}

	get order_id() {
		return this.payment.order_id;
	}

	get is_redirect() {
		return this.payment.is_redirect;
	}

	get redirect_url() {
		return this.payment.redirect_url;
	}

	get external_id() {
		return this.payment.external_id;
	}

	get sberpayAvailable() {
		return this.payment.sberpayAvailable;
	}

	get sbpAvailable() {
		return this.payment.sbpAvailable;
	}

	get tpayAvailable() {
		return this.payment.tpayAvailable;
	}

	get unavailablePaymentSystems() {
		return !this.payment.sbpAvailable && !this.payment.sberpayAvailable && !this.payment.tpayAvailable;
	}
	
}


export class PaymentApi extends API {
	static getState(idOrder: number) {
		return this.get<{ state: string; }>(`/ca/tsp/order/payment/state?idOrder=${idOrder}`)
	}

	static sendPromocode(idOrder: number, promocode: string) {
		return this.get<{ isValid: boolean; }>(`/ca/promocode/${idOrder}?promo_code=${promocode}`);
	}

	static getPayment(idOrder: number, redirectUrl: string, paymentMethod?: string, promocode?: string) {
		let url = `/ca/tsp/order/payment?idOrder=${idOrder}`;
		if (promocode) {
			url += `&promocode=${promocode}`;
		}

		if (paymentMethod) {
			url += `&payment_method=${paymentMethod}`
		}

		if (redirectUrl) {
			url += `&redirect_url=${redirectUrl}`;
		}

		return this.get<Payment>(url)
	}
}
